export enum ClientState {
    client = 'client',
    lead = 'lead',
}
